// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--bdc-sect-const-cont{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.scl--bdc-cp-const-sty-box{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.scl--bdc-cp-const-sty-box h3, .scl--bdc-cp-const-sty-box p{
    padding: 0;
    margin: 0;
}

.scl--bdc-cp-const-sty-box h3{
    font-family: var(--font-family-inter);
    font-size: 36px;
    font-weight: 600;
    color: var(--typography-text-body-primary);
}

.scl--bdc-cp-const-sty-box p{
    font-family: var(--font-family-inter);
    font-size: 16px;
    font-weight: 400;
    color: var(--typography-text-body-secondary);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/navigation-fs-cp/breadcrumb-nav-op/page-main-bcb/css/main-bcb.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,4CAA4C;AAChD","sourcesContent":[".scl--bdc-sect-const-cont{\n    width: 100%;\n    height: auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.scl--bdc-cp-const-sty-box{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.scl--bdc-cp-const-sty-box h3, .scl--bdc-cp-const-sty-box p{\n    padding: 0;\n    margin: 0;\n}\n\n.scl--bdc-cp-const-sty-box h3{\n    font-family: var(--font-family-inter);\n    font-size: 36px;\n    font-weight: 600;\n    color: var(--typography-text-body-primary);\n}\n\n.scl--bdc-cp-const-sty-box p{\n    font-family: var(--font-family-inter);\n    font-size: 16px;\n    font-weight: 400;\n    color: var(--typography-text-body-secondary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
